var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSplitLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.747067 25.87969c-.564153-1.130925-2.106977-2.250578-4.229459-3.129469l-.455315.827843c1.963928.813236 3.32115 1.806684 3.773171 2.712824.452021.906139.292505 1.665419-.01128 2.000789-.15189.167684-.320174.249701-.55916.258696-.238987.009-.56823-.07313-.958292-.345641-.780124-.545018-1.749145-1.84951-2.521548-4.257987l-.958484.296747c.805188 2.510704 1.80852 3.966901 2.844222 4.690473.517852.361787 1.057172.54012 1.57888.520482.521708-.01964 1.006376-.254849 1.330105-.612245.647459-.714789.731314-1.831587.16716-2.962512z",
    fill: "#d00000",
    stroke: "#4a0000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.526392 22.839074-1.917217-1.344334-3.251589-12.1350967c-1.8124728.9835137-.9665225 5.3686187-.112373 8.3913397l1.300698 4.854272 2.89945 2.010171z",
    fill: "#d5d5d5",
    stroke: "#717171",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.0273438 9.5019531c-2.8183472.0466368-5.2870436 1.2538899-6.2832032 4.1933599-.98846783 2.91677 1.1705509 8.183301 5.9316406 5.841796 1.0301673-.506636 1.9215798-.859622 2.7050778-1.099609l1.007813-8.4746094c-1.127842-.3031508-2.2675136-.479038-3.3613282-.4609375z",
    fill: "#8cbe8c",
    stroke: "#555753",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.851562 10.798828.53125 7.535156c1.582361.661554 2.072438 2.166016 3.173829 2.166016 2.438571 0 4.941406-1.699014 4.941406-3.873047 0-1.944514.0964-3.806221-.992188-4.876953-1.894133-1.863071-2.899234.736606-7.654297-.951172z",
    fill: "#8cbe8c",
    stroke: "#555753",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.470715 25.061797-.995208.02352c-.0856 2.518003-.681693 4.084403-1.311178 4.761041-.3147438.338319-.6163133.483516-.8765206.526998-.2602061.04349-.4983125-.0082-.7203089-.153564-.4439931-.290633-.7803554-.989712-.5278724-1.939791.2524806-.950078 1.0989684-2.154863 3.0239959-3.339695l-.526892-.740668c-2.0846996 1.283109-3.136809 2.67736-3.4657954 3.915329-.3289864 1.237968.070313 2.315948.88511 2.849305.4073984.266679.9294699.388677 1.4609711.29986.5315006-.08882 1.0531723-.381948 1.4939503-.855744.881558-.94759 1.470053-2.707986 1.559751-5.346592z",
    fill: "#d00000",
    stroke: "#4a0000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.315939 24.699723 6.200847-15.5968941c.04869 5.7352581-2.446634 11.0440081-4.399758 16.5078321z",
    fill: "#d5d5d5",
    stroke: "#717171",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSplitLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/split_line.b30451ac.svg";
export { ForwardRef as ReactComponent };